import React from 'react';
import { motion } from 'framer-motion';
export function Header() {
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + start - 80;
    const duration = 2000;
    const startTime = performance.now();
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-[#09090b]/80 backdrop-blur-xl border-b border-[#27272a]" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-99">
        {/* Logo */}
        <div className="font-extrabold text-lg md:text-xl tracking-tight text-white flex items-center gap-2" data-id="element-100">
          <div className="w-6 h-6 rounded-md bg-gradient-to-br from-[#00f0ff] to-[#8b5cf6] flex items-center justify-center" data-id="element-101">
            <span className="text-black text-xs font-black" data-id="element-102">∞</span>
          </div>
          INFINITY TECH
        </div>

        {/* Center area */}
        <div className="flex items-center gap-4" data-id="element-103">
          {/* Badge - Hidden on small screens */}
          <motion.div animate={{
          opacity: [0.6, 1, 0.6]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="hidden lg:flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 border border-red-500/20 text-red-400 text-xs font-bold tracking-wide" data-id="element-104">
            <div className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-105" />
            OFERTA LIMITADA
          </motion.div>

          {/* VER OFERTA Button */}
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={scrollToPricing} className="bg-gradient-to-b from-[#f5c518] to-[#d97706] text-black font-bold text-xs md:text-sm px-5 py-2 rounded-xl shadow-[0_2px_10px_rgba(245,197,24,0.2)] transition-all border border-[#f5c518]/50" data-id="element-106">
            VER OFERTA
          </motion.button>
        </div>
      </div>
    </header>;
}